import React, { Suspense, lazy, useEffect, useState } from 'react'
import { useAppDispatch } from '../../store'
import { type ApplyFiltersAndDispatchParams, type Row } from '../../components/CustomTable/types'
import LoadingPage from '../../pages/LoadingPage'
import { getFacultyAndStaffApi } from '../../store/slices/facultyAndStaffSlice/apis'
import { getLoading, getUserList } from '../../store/slices/facultyAndStaffSlice/selectors'
import CreateAndEditFacultyAndStaff from './CreateAndEditFacultyAndStaff'
import FacultyAndStaffTopbarActions from './FacultyAndStaffTopbarActions'
import DeleteFaculty from './DeleteFaculty'

const AppTable = lazy(async () => await import('../../components/CustomTable'))

const FacultyAndStaff = (): JSX.Element => {
  const isLoading = getLoading()
  const userList = getUserList()
  const dispatch = useAppDispatch()

  const [params, setParams] = useState<ApplyFiltersAndDispatchParams>({
    pageSize: 15
  })

  useEffect(() => {
    void dispatch(getFacultyAndStaffApi({ params }))
  }, [params])

  const columns = userList?.keys ?? []
  const rows: Row[] = userList?.data ?? []
  const tableHeader = userList?.header?.headerName ?? ''

  return (
    <Suspense fallback={<LoadingPage />}>
      <AppTable
        topbarTitle={tableHeader}
        customTopbarAction={<FacultyAndStaffTopbarActions params={params} />}
        list={userList}
        rows={rows}
        loading={isLoading}
        columns={columns}
        featureName="Faculty"
        params={params}
        setParams={setParams}
        editAction={<CreateAndEditFacultyAndStaff />}
        deleteAction={<DeleteFaculty params={params} />}
        actionModalEntityDisplayField="firstName"
      />
    </Suspense>
  )
}

export default FacultyAndStaff
